"use client";

import React from "react";
import useHeader from "../../hooks/useHeader";
import { usePathname } from "next/navigation";
import Box from "@sendsprint/ui-react/components/box";
import cs from "classnames";
import Link from "next/link";
import { Path } from "@/navigations/routes";
import Logo from "@/assets/svgs/logo-full-green.svg";
import LogoWhite from "@/assets/svgs/logo-white.svg";
import { checkTextWhite } from "../../utils/checkTextWhite";
import DesktopNavigation from "./desktopNavigation";
import MobileNavigation from "./mobileNavigation";
import Container from "@sendsprint/ui-react/components/container";

interface Props {
  showNavigation?: boolean;
}

const Header = ({ showNavigation = true }: Props) => {
  const headerLogic = useHeader();
  const pathname = usePathname();

  const { isSolid } = headerLogic;

  const isTextWhite = checkTextWhite(pathname ?? "");
  const showWhite = isTextWhite && !isSolid;

  return (
    <Box
      as="header"
      className={cs("ss:transition-all ss:fixed ss:w-full ss:top-0 ss:z-30", {
        "ss:bg-white/70 ss:text-primary1-500 ss:backdrop-blur ss:shadow":
          isSolid,
        "ss:bg-transparent": !isSolid,
        "ss:text-white": showWhite,
      })}
    >
      <Container>
        <Box className="ss:flex ss:items-center ss:justify-between ss:py-3 ss:xl:py-5">
          <Link
            aria-label="Go to home page"
            href={Path.Home}
            className="ss:z-20"
          >
            {showWhite ? (
              <LogoWhite className="ss:h-10 ss:w-32 ss:md:w-44 ss:xl:w-56 ss:md:h-10" />
            ) : (
              <Logo className="ss:h-10 ss:w-32 ss:md:w-44 ss:xl:w-56 ss:md:h-10" />
            )}
          </Link>
          {showNavigation && (
            <>
              <DesktopNavigation headerLogic={headerLogic} showWhite={showWhite} />
              <MobileNavigation headerLogic={headerLogic} />
            </>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default Header;
